import axios from "axios";
import { createMessage, createGenericErrorAlert } from "./messages";
import { tokenConfigUpload, tokenConfig } from "./auth";


import { 
    UPDATE_INVOICE_ATTACHMENTS, 
    UPDATE_CONTRACT_ATTACHMENTS, 
    UPDATE_INVOICE_ATTACHMENTS_ADDITIONAL, 
    GET_USER_ICON_PATH, 
    GET_NOTIFICATIONS, 
    REMOVE_NOTIFICATION, 
    READ_NOTIFICATION,
    TOGGLE_SIDEBAR, 
    SET_SIDEBAR_PAGE,
    CLEAR_ALL_DROPS 
} from "./types";

// CREATE CONTRACT
export const uploadContractAttachment = (id, file_name, formData) => (dispatch, getState) => {
    axios
        .post(`/v0/api/core/upload/contract/${id}/${file_name}/`, formData, tokenConfigUpload(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch(createMessage({ success: "Contract successfully uploaded" }))
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})))
};

//UPLOAD DOCUMENT ATTACHMENTS
export const uploadFileAttachment = (content_type, id, file_name, formData) => (dispatch, getState) => {
    if (content_type === "Invoice") {
        axios
            .post(`/v0/api/core/upload/file-attachment/${content_type}/${id}/${file_name}/`, formData, tokenConfigUpload(getState))
            .then((res) => {
                if (res.data.error) {
                    dispatch(createMessage({ error: res.data.error }))
                } else {
                    dispatch({
                        type: UPDATE_INVOICE_ATTACHMENTS,
                        payload: res.data,
                    });
                }
            })
            .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})))
    } else if (content_type === "InvoiceAdd") {
        axios
            .post(`/v0/api/core/upload/file-attachment/${content_type}/${id}/${file_name}/`, formData, tokenConfigUpload(getState))
            .then((res) => {
                if (res.data.error) {
                    dispatch(createMessage({ error: res.data.error }))
                } else {
                    dispatch({
                        type: UPDATE_INVOICE_ATTACHMENTS_ADDITIONAL,
                        payload: res.data,
                    });
                }
            })
            .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})))
    } else if (content_type === "Contract") {
        axios
            .post(`/v0/api/core/upload/file-attachment/${content_type}/${id}/${file_name}/`, formData, tokenConfigUpload(getState))
            .then((res) => {
                if (res.data.error) {
                    dispatch(createMessage({ error: res.data.error }))
                } else {
                    dispatch({
                        type: UPDATE_CONTRACT_ATTACHMENTS,
                        payload: res.data,
                    });
                }
            })
            .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})))
    }
};

// EDIT UPLOAD_ATTACHMENT INFORMATION
export const editContractAttachment = (id) => (dispatch, getState) => {
    axios
        .put(`/v0/api/core/update-attachment/${id}/`, { a: 'body' }, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch(createMessage({ success: "Contract successfully edited" }))
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})))
};

// GET USER ICON PATH
export const getUserIconPath = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/core/get-user-icon-path/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_USER_ICON_PATH,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})))
};

// GET NOTIFICATIONS
export const getNotifications = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/core/get-notifications/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_NOTIFICATIONS,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})))
};

// REMOVE NOTIFICATION
export const removeNotification = (id) => (dispatch, getState) => {
    axios
        .put(`/v0/api/core/update-notification/${id}/`, { a: 'body' }, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: REMOVE_NOTIFICATION,
                    payload: id,
                    //payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})))
    //.catch((err) => console.log(err));
};

// READ NOTIFICATION
export const readNotification = (id) => (dispatch, getState) => {
    axios
        .put(`/v0/api/core/update-notification/${id}/`, { read: true }, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: READ_NOTIFICATION,
                    payload: id,
                    //payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})))
    //.catch((err) => console.log(err));
};

// TOGGLE SIDEBAR
export const toggleSidebar = () => (dispatch) => {
    dispatch({
        type: TOGGLE_SIDEBAR,
        payload: null,
        //payload: res.data,
    });
};
// SET ACTIVE SIDEBAR PAGE
export const setActiveSidebarPage = (id) => (dispatch) => {
    dispatch({
        type: SET_SIDEBAR_PAGE,
        payload: id,
    });
};

// CLEAR ALL MANAGEMENT DROPS
export const clearAllDrops = () => (dispatch) => {
    dispatch({
        type: CLEAR_ALL_DROPS,
        payload: null,
    });
};

